// extracted by mini-css-extract-plugin
export default {"logoStyle":"BannerStyle_logoStyle__AQd9z"};